export default "__VITE_ASSET__6bfc3cfb__"